import React from 'react';
import { motion } from 'framer-motion';
import { Shield, FileCheck, MapPin, DollarSign } from 'lucide-react';
export function AboutSection() {
  return <section id="about" className="py-24 bg-sunrise-cream relative overflow-hidden" data-id="element-10">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-sunrise-cream-dark/30 -skew-x-12 translate-x-1/4" data-id="element-11" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-13">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-14">
            <span className="text-sunrise-orange font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-15">
              About Us
            </span>
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-sunrise-charcoal mb-6 leading-tight" data-id="element-16">
              Craftsmanship Built on{' '}
              <span className="text-sunrise-brown" data-id="element-17">Trust</span>
            </h2>
            <div className="prose prose-lg text-gray-600" data-id="element-18">
              <p className="mb-6" data-id="element-19">
                Founded by Bryan Rivas, Sunrise Door n Trim brings meticulous
                craftsmanship to every project. We serve homeowners planning
                renovations and general contractors who need a reliable finish
                carpentry partner.
              </p>
              <p data-id="element-20">
                Every detail matters — from the grain of the wood to the
                precision of the cut. That's the Sunrise standard. We don't just
                install; we enhance your home's character with permanent,
                high-quality finishes.
              </p>
            </div>
          </motion.div>

          <div className="space-y-6" data-id="element-21">
            {[{
            icon: Shield,
            title: 'Licensed, Bonded & Insured',
            desc: 'Complete peace of mind for every client.'
          }, {
            icon: FileCheck,
            title: 'ROC #363248',
            desc: 'Fully registered Arizona contractor.'
          }, {
            icon: MapPin,
            title: 'Serving the Valley',
            desc: 'Gilbert, Phoenix, Mesa, Chandler & Scottsdale.'
          }, {
            icon: DollarSign,
            title: 'Free Estimates',
            desc: 'Transparent pricing with no hidden fees.'
          }].map((item, index) => <motion.div key={item.title} initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start bg-white p-6 rounded-xl shadow-sm border border-sunrise-cream-dark" data-id="element-22">
                <div className="flex-shrink-0" data-id="element-23">
                  <div className="w-12 h-12 bg-sunrise-orange/10 rounded-full flex items-center justify-center" data-id="element-24">
                    <item.icon className="w-6 h-6 text-sunrise-orange" data-id="element-25" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-26">
                  <h3 className="text-lg font-bold text-sunrise-charcoal" data-id="element-27">
                    {item.title}
                  </h3>
                  <p className="text-gray-500" data-id="element-28">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}